export const RESPONSE_STATUS_SET = 'RESPONSE_STATUS_SET';
export const RESPONSE_STATUS_INIT = 'RESPONSE_STATUS_INIT';



// WEBPACK FOOTER //
// ./shared/common/redux/actions.responseStatus.types.js